export default "__VITE_ASSET__3e35b834__"